export const APP_NAME = 'ZIGMA TRADER AI'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const ADMIN_ID = 1